import React, { useState } from "react";
import axios from "axios";
import PhoneInputComponent from "./phone_input_comp";
import { isValidPhoneNumber } from "libphonenumber-js";
import "./contact_form.css";
import "./ModalStyles.css";
import { CALL_ME_ENDPOINT } from './config';


function ContactForm({ isModal = false, onClose = () => { } }) {
  const [formData, setFormData] = useState({
    name: "",
    number: "+1",
    comment: ""
  });
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (event) => {
    if (typeof event === "string") {
      setFormData(prev => ({ ...prev, number: event }));
    } else {
      const { name, value } = event.target;
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!isValidPhoneNumber(formData.number, "US")) {
      formErrors.number = "Phone Number is invalid.";
    }
    if (!formData.name.trim()) {
      formErrors.name = "Full Name is required.";
    }
    // if (!formData.comment.trim()) {
    //   formErrors.comment = "Message is required.";
    // }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      const response = await axios.post(CALL_ME_ENDPOINT, formData);
      console.log('Call me request added:', response.data);
      setFormData({
        name: '',
        number: '+1',
        comment: ''
      });
      setShowSuccessModal(true);
    } catch (error) {
      console.error("There was an error adding the call me request!", error);
    }
  };

  return (
    <div className={isModal ? "contact-form-container modal-contact" : "contact-form-container"}>
      <h2 className="form-title"></h2>

      <form onSubmit={handleSubmit} className="contact-form" id="call-me-section">
        {/* Two-column row for name + phone */}
        <div className="two-column-row">
          <div className="left-col">
            <div className="input-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your full name"
                className={`input-field ${errors.name ? "error-input" : ""}`}
              />
              {errors.name && <div className="error-text">{errors.name}</div>}
            </div>
          </div>

          <div className="right-col">
            <div className="input-group">
              <PhoneInputComponent
                value={formData.number}
                onChange={handleChange}
                errorMessage={errors.number}
              />
            </div>
          </div>
        </div>

        <div className="input-group">
          <textarea
            name="comment"
            value={formData.comment}
            onChange={handleChange}
            placeholder="Your message..."
            className={`textarea-field ${errors.comment ? "error-input" : ""}`}
          />
          {errors.comment && <div className="error-text">{errors.comment}</div>}
        </div>

        <button type="submit" className="submit-btn">Call me</button>
      </form>

      {showSuccessModal && (
        <SuccessModal onClose={() => setShowSuccessModal(false)} />
      )}
    </div>
  );
}

function SuccessModal({ onClose }) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Success</h2>
        <p>Your call me request has been submitted!</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
}

export default ContactForm;